import { render, staticRenderFns } from "./assurance-societes.html?vue&type=template&id=810e6bec&scoped=true&external"
import script from "./assurance-societes.js?vue&type=script&lang=js&external"
export * from "./assurance-societes.js?vue&type=script&lang=js&external"
import style0 from "./assurance-societes.scss?vue&type=style&index=0&id=810e6bec&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810e6bec",
  null
  
)

export default component.exports